import Vuebar from 'vuebar';
export default defineNuxtPlugin(function (nuxtApp) {
  nuxtApp.vueApp.use(Vuebar);
});